export enum AccessRestrictionReasons {
  InBadDebt = 'IN_BAD_DEBT',
}
